/**
 * Client-side rate limiter for AI chat requests.
 * Enforces a 60-second cooldown between consecutive AI requests.
 */

const COOLDOWN_SECONDS = 60

let lastRequestTimestamp: number | null = null

/**
 * Returns true if enough time has passed since the last request
 * and a new AI request is allowed.
 */
export function canRequest(): boolean {
  if (lastRequestTimestamp === null) return true
  const elapsed = (Date.now() - lastRequestTimestamp) / 1000
  return elapsed >= COOLDOWN_SECONDS
}

/**
 * Records the current timestamp as the last request time.
 * Call this immediately after a successful AI request is initiated.
 */
export function recordRequest(): void {
  lastRequestTimestamp = Date.now()
}

/**
 * Returns the number of seconds remaining in the cooldown period.
 * Returns 0 if no cooldown is active (request is allowed).
 */
export function getSecondsRemaining(): number {
  if (lastRequestTimestamp === null) return 0
  const elapsed = (Date.now() - lastRequestTimestamp) / 1000
  const remaining = COOLDOWN_SECONDS - elapsed
  return remaining > 0 ? Math.ceil(remaining) : 0
}
